import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ActionsUserIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M12 12.75c5.79 0 10.5 4.71 10.5 10.5 0 .414-.336.75-.75.75s-.75-.336-.75-.75c0-4.963-4.037-9-9-9s-9 4.037-9 9c0 .414-.336.75-.75.75s-.75-.336-.75-.75c0-5.79 4.71-10.5 10.5-10.5zM12 0c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6c0-1.051.278-2.087.805-2.997l.009-.017C7.892 1.142 9.864.006 12 0zM7.731 4.587C7.578 5.042 7.5 5.52 7.5 6c0 2.481 2.019 4.5 4.5 4.5 2.35-.003 4.303-1.811 4.487-4.154-.884.267-1.803.403-2.727.404h-.02c-2.191-.013-4.312-.776-6.009-2.163zM12 1.5c-1.39 0-2.693.642-3.545 1.732 1.461 1.292 3.342 2.01 5.293 2.018.887 0 1.757-.146 2.592-.434C15.803 2.861 14.028 1.504 12 1.5z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ActionsUserIcon = __decorateClass([
  customElement("elm-actions-user-icon")
], ActionsUserIcon);
export { ActionsUserIcon };
